"use client";

import type { Agent } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

type Props = {
  draft: Agent;
  onChange: (next: Agent) => void;
};

export function AgentEditEndOfCallPanel({ draft, onChange }: Props) {
  function patch(partial: Partial<Agent>) {
    onChange({ ...draft, ...partial });
  }

  return (
    <div className="agent-conv">
      <section className="agent-conv-block">
        <h3 className="agent-conv-h">Session complete page</h3>
        <p className="agent-conv-help" style={{ marginBottom: 16 }}>
          Applies to every new Conversation session for this agent (Cascade, Direct, and
          LiveAvatar). Customers see this after they hang up on pulse.igentify.in.
        </p>
        <div className="agent-perc-live-row">
          <div>
            <div className="agent-perc-signal-title">
              <b>Transcript summary &amp; download</b>
            </div>
            <span>
              When on, the complete page shows the conversation transcript and a Download
              transcript action (PDF). When off, only the session summary card is shown (duration,
              session ID, next steps).
            </span>
          </div>
          <Switch
            checked={draft.completePageTranscriptEnabled !== false}
            onCheckedChange={(v) => patch({ completePageTranscriptEnabled: v })}
            aria-label="Show transcript summary and download on complete page"
          />
        </div>
      </section>
    </div>
  );
}
